import React from 'react';
import Select from 'react-select';
import { Datepicker } from '../common/Datepicker';
import DatePicker from 'react-datepicker';
import moment from 'moment';
// import '../styles/CustomStyle.scss';
// import 'react-select/dist/react-select.css';


class CustomDate extends React.Component {
    constructor(props) {
        super(props);
        this.setValue = this.setValue.bind(this);
        this.SmartSelectRef = React.createRef();
        //var labelVal =this.getLabel(this.props.values, this.props.node.data[this.props.colDef.field]);
        this.state = {
            StartDate:props.value!=null? moment(props.value).toDate():null
           
        };
    };
   
   

        render() {
    return (
     <div>
       <DatePicker selected={this.state.StartDate} minDate={new Date("01-01-2001")}
    maxDate={new Date("02-29-2096")}  onChange={(date) => {
                                 this.props.node.setDataValue(this.props.colDef.field, date);

                            }}   onSelect={(date) => {
                                this.setState({StartDate: date});
                                this.props.node.setDataValue(this.props.colDef.field, date);

                           }}/>
     </div>
    );

  }

    componentDidMount() {
    };

    setValue(val) {
    }

};

export default CustomDate;


